import React, { SyntheticEvent, useCallback, useEffect, useState } from 'react'
import Loading from 'Components/loading'
import Button from 'Components/button'

interface ITopicSelector {
  chooseTopic: (t: ITopic) => void
  inputValue: string
  onChange: (e: SyntheticEvent) => void
  topicState: {
    topicList: ITopic[]
    loaded: boolean
    keyword: string
  }
}

export interface ITopic {
  name: string
  user_count: number
  intro: string
}
export default function TopicSelector(props: ITopicSelector) {
  const { chooseTopic, inputValue, onChange, topicState } = props

  const { topicList, loaded } = topicState
  return (
    <div className="topic-wrap">
      <div className="top-form">
        <input
          onChange={onChange}
          placeholder="请输入你要搜索的话题"
          className="topic-search"
          value={inputValue}
        />
        <Button className="search-btn" type="new_primary">
          搜索
        </Button>
      </div>
      <ul className="topic-list">
        {topicList?.map((item, index) => (
          <div
            className="top-item"
            key={index}
            onClick={() => chooseTopic(item)}
          >
            <p className="topic-item-tit">
              <span className="title">{item.name}</span>
              <span className="user-count">{item.user_count}人参与话题</span>
            </p>
            <p className="topic-item-info">{item.intro}</p>
          </div>
        ))}
        {loaded ? (
          !topicList.length ? (
            <p className="search-remind">未找到你想要的话题</p>
          ) : null
        ) : (
          <Loading />
        )}
      </ul>
      <style jsx>
        {`
          .topic-wrap {
            margin-top: 16px;
          }
          .top-form {
            width: 346px;
            position: relative;
            border-radius: 2px;
            height: 36px;
            overflow: hidden;
          }
          .topic-search:focus {
            outline: none;
            border-color: ;
          }
          .topic-search {
            width: 266px;
            border: 1px solid #c9cbd6;
            border-right: none;
            height: 100%;
            padding: 8px 16px;
          }
          :global(.top-form .search-btn) {
            border-radius: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 80px;
            height: 100%;
            position: absolute;
            right: 0;
            top: 0;
          }

          .topic-list {
            display: flex;
            flex-direction: column;
            justify-content: stretch;
            margin-top: 8px;
            overflow-y: scroll;
            height: 164px;
          }
          .top-item {
            padding: 8px 16px;
            background-color: #f7f8fc;
            margin-bottom: 4px;
            box-sizing: border-box;
            width: 346px;
            height: 58px;
            border-radius: 2px;
          }
          .top-item:hover {
            border: 1px solid #f5b330;
          }
          .topic-item-tit {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .title {
            font-size: 14px;
            line-height: 1.5;
            color: #1f2129;
            font-weight: 500;
            max-width: 215px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .user-count {
            color: #606370;
            font-size: 12px;
            line-height: 1.8;
            transform: scale(0.833);
            transform-origin: center right;
            white-space: nowrap;
            flex: 0 0 auto;
          }
          .topic-item-info {
            max-width: 314px;
            color: #606370;
            font-size: 12px;
            line-height: 1.75;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .search-remind {
            display: block;
            margin-top: 56px;
            text-align: center;
          }
        `}
      </style>
    </div>
  )
}
